import { useCallback, useEffect, useState } from "react";
import CommonTable from "../CommonTable";
import HttpService from "@/hooks/Https-services";
import PageRoutes, { APIRoutes } from "@/utils/constants";
import { Box, Skeleton, Typography } from "@mui/material";
import useConfig from "@/hooks/useConfig";
import { useTeamContext } from "@/Common/Contex/TeamContext";
import momentTimezone from "moment-timezone";
import { useNavigate } from "react-router-dom";
const userTimeZone = momentTimezone.tz.guess();
const UpcomingSchedule = () => {
  const headers: any = [
    { id: "date", label: "Date", align: "left", width: "100%" },
  ];
  const config = useConfig();
  const { currentSelectedTeam }: any = useTeamContext();
  const [rows, setRows] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  // Your data rows

  // Custom cell renderer for formatting date and showing team logo
  const renderCell = (row: any, columnId: string, index: number) => {
    if (columnId === "date") {
      // Format the date nicely
      try {
        const eventDate = row?.game_date_time;
        const findOpponent =
          row?.away_team_id == currentSelectedTeam?.team_id ? "home" : "away";
        return (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontStyle: "normal" }}
              >
                {momentTimezone
                  .tz(
                    eventDate,
                    "YYYY-MM-DD hh:mm:ss.SSSSSS a Z",
                    "America/New_York"
                  )
                  .tz(userTimeZone)
                  .format("YYYY-MM-DD")}{" "}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {momentTimezone
                  .tz(
                    eventDate,
                    "YYYY-MM-DD hh:mm:ss.SSSSSS a Z",
                    "America/New_York"
                  )
                  .tz(userTimeZone)
                  .format("h:mm a z")}{" "}
              </Typography>
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                {row[`${findOpponent}_team_logo`] && (
                  <Box
                    component="img"
                    src={row[`${findOpponent}_team_logo`]}
                    alt={row[`${findOpponent}_team_name`] || "Team logo"}
                    sx={{
                      height: 30,
                      width: 30,
                      objectFit: "contain",
                      mr: 1,
                    }}
                  />
                )}
                <Typography
                  variant="body2"
                  sx={{ fontStyle: "normal", textTransform: "none" }}
                >
                  {`${row[`${findOpponent}_team`]} ${
                    row[`${findOpponent}_team_mascot`] ||
                    row[`${findOpponent}_team_short_name`] ||
                    "-"
                  }`}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      } catch (error) {
        return row.event_date || "-";
      }
    }

    // Default rendering for other columns
    return row[columnId] || "-";
  };

  const GetSchedule = useCallback(async () => {
    if (!currentSelectedTeam?.team_id) {
      return;
    }
    try {
      setIsLoading(true);
      const params: any = {
        status: "live",
        page: 1,
        limit: 6,
        customer: config.customer,
        team: currentSelectedTeam?.team_id,
      };
      const games = await HttpService.getapi(
        `${APIRoutes.TeamEventsList}?` + new URLSearchParams(params)
      );

      setRows(games?.data?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [config.customer, currentSelectedTeam?.team_id]);
  useEffect(() => {
    GetSchedule();
  }, [GetSchedule]);

  // Handle row click
  const handleRowClick = (row: any) => {
    // You can navigate to game details or perform any action when a row is clicked
    console.log("Row clicked:", row);

    // Example: Open game details or show more information
    if (row?.game_id) {
      navigate(PageRoutes.Watch.replace(":gameId", row.game_id));
      // You could navigate to a game details page or open a modal
      // Example: navigate(`/game/${row.game_id}`)
      // Or open a modal with game details
    }
  };
  if (isLoading) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
        <Skeleton variant="rectangular" sx={{ height: 50 }} />
      </Box>
    );
  }

  return (
    <CommonTable
      headers={headers}
      rows={rows}
      renderCell={renderCell}
      maxHeight={500}
      title="Upcoming Schedule"
      emptyMessage="No team data available"
      bodyRowProps={(row: any) => ({
        onClick: () => handleRowClick(row),
        sx: {
          cursor: "pointer",
          "&:hover": {
            backgroundColor: `${
              currentSelectedTeam?.team_secondary_color || config.secondary
            }22`, // Adding transparency
          },
        },
      })}
    />
  );
};
export default UpcomingSchedule;
